'use client';
import { useMobileNavStore } from '@/store/mobileNavStore';
import Image from 'next/image';

type ButtonSpanImageProps = {
  name?: string;
  className: string;
  image: string;
  searchLabel: string;
};
const ButtonSpanImage = ({
  // name,
  className,
  image,
  searchLabel,
}: ButtonSpanImageProps) => {
  const { toggleSearch } = useMobileNavStore();
  return (
    <button className={className} onClick={toggleSearch}>
      <span className="d-none d-lg-inline">{searchLabel}</span>
      <Image width={40} height={40} src={image} alt="search" />
    </button>
  );
};

export default ButtonSpanImage;
